import { GET_SUBJECT } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_SUBJECT:
            return action.payload;
        default:
            return state;
    }
}
